<template>
  <el-container class="SaleBulkChange">
    <el-main class="p-0">
      <el-form
        ref="form"
        class="form-label-80"
        label-width="80px"
        :model="data"
        :rules="rules"
      >
        <el-form-item prop="sale_date" label="매출일">
          <el-checkbox v-model="selection.sale_date" />
          <div class="inline pl-default">
            <ADatePicker
              v-model="data.sale_date"
              @change="handleChangeSaleDate"
            />
          </div>
        </el-form-item>
        <el-form-item prop="delivery_date" label="납기일">
          <el-checkbox v-model="selection.delivery_date" />
          <div class="inline pl-default">
            <ADatePicker
              v-model="data.delivery_date"
              @change="handleChangeDeviveryDate"
            />
          </div>
        </el-form-item>
      </el-form>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['F4']"
        :disabled="disableRegister"
        :loading="load_button"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
        >{{ $t("button.register") }}(F4)</el-button
      >
      <el-button
        class="close-button"
        :loading="load_button"
        @click="handleCloseDialog"
        >{{ $t("button.close") }}(Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>

<script>
export default {
  name: "SaleBulkChange",
  data() {
    let validateSaleDate = (rule, value, callback) => {
      if (!this.selection.sale_date || this.data.sale_date) {
        callback();
      } else {
        callback(new Error("매출일을 선택해 주세요."));
      }
    };
    let validateDevliveryDate = (rule, value, callback) => {
      if (!this.selection.delivery_date || this.data.delivery_date) {
        callback();
      } else {
        callback(new Error("납기일을 선택해 주세요."));
      }
    };
    return {
      title: this.$t("title.sale"),
      selection: {
        sale_date: false,
        delivery_date: false,
      },
      data: {
        sale_date: null,
        delivery_date: null,
      },
      rules: {
        sale_date: [{ validator: validateSaleDate, trigger: "blur" }],
        delivery_date: [{ validator: validateDevliveryDate, trigger: "blur" }],
      },
      load_button: false,
    };
  },
  props: {
    ids: {
      type: Array,
      required: true,
    },
  },
  computed: {
    disableRegister() {
      return !this.selection.sale_date && !this.selection.delivery_date;
    },
  },
  methods: {
    doRegister() {
      let data = {};
      if (this.selection.sale_date) {
        data.sale_date = this.data.sale_date;
      }
      if (this.selection.delivery_date) {
        data.delivery_date = this.data.delivery_date;
      }
      let param = {
        ids: this.ids,
        data: data,
      };
      this.load_button = true;
      this.api.updateSaleBulk(param).then((res) => {
        this.load_button = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.util.notify_success(this, this.title, "등록되었습니다.");
        this.$emit("completed", true);
      });
    },
    handleChangeSaleDate() {
      this.selection.sale_date = !!this.data.sale_date;
    },
    handleChangeDeviveryDate() {
      this.selection.delivery_date = !!this.data.delivery_date;
    },
    handleClickRegister() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.doRegister();
      });
    },
    handleCloseDialog() {
      this.$emit("completed");
    },
  },
};
</script>
